import React from 'react';
import { Component } from 'react';
import TimeSelection from '../contents/timeselection/TimeSelection';
import { InitialState } from '../data/initialState';
import { connect } from 'react-redux';
import Header from './Header';
import { linkPlaceholder } from '../utils/TranslationUtils';

class TimeSelectionCont extends Component {
    constructor(props) {
        super(props);
        this.elems = {};
    }

    finalSubmit(e) {
        this.props.updateValue("setAppointmentId", true);
        const { location, day, time } = this.props.values;
        let duration = null;
        if (window.Tesla.country.toUpperCase() == "CN" && (location == "" || location == null)) {
            document.getElementById("location-msg").setAttribute('class',"tds-form-item-feedback tds-form-item-feedback-msg")
            document.getElementById("location-msg").innerHTML = "请选择门店";
            document.getElementById("location").setAttribute('class',"item-container tds-form-item--error")
            return false;
        }
        const times = this.props.getData()[location].appointmentTimeSlots.times;
        if (times != null) {
            duration = times[day][time].duration;
        }
        this.props.updateValue("duration", duration);
        this.props.handleSubmit(e);
    }

    render() {
        let { containerClass, getData, getModel, handleChange, updateValue, getSortedData } = this.props;

        const timeSelection = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.timeSelection : {};

        return (
            <div className={'content-container time-container ' + containerClass}>
                <Header 
                    title={timeSelection.title}
                    title2={linkPlaceholder(
                        timeSelection.title2,
                        { LEARN_MORE: timeSelection.title2Lbl },
                        '/support/test-drive'
                    )}
                    title3={timeSelection.title3} />
                <TimeSelection
                    handleChange={handleChange}
                    getData={getData}
                    getSortedData={getSortedData}
                    getModel={getModel}
                    updateValue={updateValue} />
                <div className='btn-container'>
                    <button className="tds-btn tds-btn--blue" data-section="timeSection" onClick={this.finalSubmit.bind(this)} id="edit-submit-td-ajax-3">{timeSelection.next}</button>
                </div>
                <p className='disclaimer-txt'>{timeSelection.note}</p>
            </div>
        );
    }
}

TimeSelectionCont.defaultProps = InitialState().timeSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        containerClass: _state.timeSection.containerClass,
    }
}

const TimeSelectionContainer = connect(
    mapStateToProps
)(TimeSelectionCont)

export default TimeSelectionContainer
